import { AxiosResponse } from 'axios';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { HolidaySaveRequest, HolidaysRequest } from '@/main/models/request/holidaysRequest';
import { HolidaysResponse } from '@/main/models/response/holidaysResponse';
import { IHolidaysApi } from '../base/registration/holidaysApi';
import { api } from '../base/api';
import { Result } from '@/main/models/common/resultResponse';

const baseRoute: string = 'Holiday';

export class HolidaysApi extends IHolidaysApi {
  getSearchGrid(
    request: HolidaysRequest
  ): Promise<
    AxiosResponse<
      PaginationResponse<HolidaysResponse[]>,
      any
    >
  > {
    return api.get(`${baseRoute}/searchgrid`, { params: request });
  }

  saveHoliday(
    request: HolidaySaveRequest
  ): Promise<AxiosResponse<Result<HolidaysResponse>>> {
    return api.post(`${baseRoute}/save`, request);
  }

  changeStatusHoliday(
    request: HolidaySaveRequest
  ): Promise<AxiosResponse<Result<void>>> {
    return api.put(`${baseRoute}/changestatusholiday`, request);
  }
}


